import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Torf-Zersetzungsgrad nach von Post (H1–H10)</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<table class="table table-sm table-bordered zersetzung-table">
				<thead>
					<tr>
						<th>Gruppe</th>
						<th>Stufe</th>
						<th>Bezeichnung</th>
						<th>Pflanzenstruktur</th>
						<th>Quetschen (Rückstand)</th>
						<th>Strukturierte Pflanzenreste</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of rows" [class.group-start]="row.groupStart">
						<td *ngIf="row.groupRowspan" [attr.rowspan]="row.groupRowspan" class="group-cell" [class.ge]="row.group === 'ge'" [class.mae]="row.group === 'mä'" [class.st]="row.group === 'st'">
							<strong>{{ row.group }}</strong><br/><span class="group-label">{{ row.groupLabel }}</span>
						</td>
						<td class="stufe-cell"><strong>{{ row.stufe }}</strong></td>
						<td>{{ row.bezeichnung }}</td>
						<td>{{ row.pflanzenstruktur }}</td>
						<td>{{ row.quetschen }}</td>
						<td>{{ row.pflanzenreste }}</td>
					</tr>
				</tbody>
			</table>
			<p class="text-muted small mt-2 mb-0">Quelle: SEA TeilA, Darst. A 2-3, S. 92</p>
		</div>
	`,
	styles: [`
		.zersetzung-table {
			font-size: 0.82rem;
			min-width: 700px;
		}
		.zersetzung-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
			white-space: nowrap;
		}
		.zersetzung-table td {
			vertical-align: middle;
		}
		.stufe-cell {
			text-align: center;
			white-space: nowrap;
		}
		.group-cell {
			text-align: center;
			vertical-align: middle;
			writing-mode: vertical-lr;
			transform: rotate(180deg);
			white-space: nowrap;
			padding: 0.5rem 0.3rem;
		}
		.group-label {
			font-size: 0.75rem;
		}
		.ge { background: #d4edda; }
		.mae { background: #fff3cd; }
		.st { background: #f8d7da; }
		.group-start td {
			border-top: 2px solid #adb5bd;
		}
	`]
})
export class ZersetzungsgradInfoModalComponent {
	constructor(public activeModal: NgbActiveModal) {}

	rows = [
		{ stufe: '1 (H1)', bezeichnung: 'nicht zersetzt', pflanzenstruktur: 'unverändert, völlig erhalten', quetschen: 'klares, farbloses Wasser; kein Torf tritt durch', pflanzenreste: 'nicht breiig, nicht verändert', group: 'ge', groupLabel: 'gering', groupRowspan: 4, groupStart: true },
		{ stufe: '2 (H2)', bezeichnung: 'fast nicht zersetzt', pflanzenstruktur: 'fast unverändert, deutlich erkennbar', quetschen: 'fast klares, gelbbraunes Wasser; kein Torf tritt durch', pflanzenreste: 'nicht breiig, kaum verändert' },
		{ stufe: '3 (H3)', bezeichnung: 'sehr schwach zersetzt', pflanzenstruktur: 'noch gut erkennbar, einzelne Reste leicht breiig', quetschen: 'deutlich trübes Wasser; kein Torf tritt durch', pflanzenreste: 'nicht breiig, wenig verändert' },
		{ stufe: '4 (H4)', bezeichnung: 'schwach zersetzt', pflanzenstruktur: 'undeutlich, zum Teil zerfallen', quetschen: 'stark trübes Wasser; kein Torf tritt durch', pflanzenreste: 'etwas breiig, zerbrochen' },
		{ stufe: '5 (H5)', bezeichnung: 'mittel zersetzt', pflanzenstruktur: 'nur noch teilweise erkennbar', quetschen: 'stark trübes Wasser; wenig Torf tritt durch', pflanzenreste: 'stark breiig, erkennbare Reste und Fasern', group: 'mä', groupLabel: 'mäßig', groupRowspan: 3, groupStart: true },
		{ stufe: '6 (H6)', bezeichnung: 'stark zersetzt', pflanzenstruktur: 'undeutlich', quetschen: 'trübe, breiige Masse; < ⅓ tritt durch', pflanzenreste: 'stark breiig, wenig erkennbare Reste' },
		{ stufe: '7 (H7)', bezeichnung: 'ziemlich stark zersetzt', pflanzenstruktur: 'kaum noch erkennbar', quetschen: 'ca. ½ des Torfes tritt durch', pflanzenreste: 'vorwiegend breiig, wenige erkennbare Reste' },
		{ stufe: '8 (H8)', bezeichnung: 'sehr stark zersetzt', pflanzenstruktur: 'sehr undeutlich, fast nicht erkennbar', quetschen: 'ca. ⅔ des Torfes tritt durch', pflanzenreste: 'breiig, vereinzelte Wurzel-/Faserreste', group: 'st', groupLabel: 'stark', groupRowspan: 3, groupStart: true },
		{ stufe: '9 (H9)', bezeichnung: 'fast vollständig zersetzt', pflanzenstruktur: 'nicht erkennbar', quetschen: 'fast alles quillt durch', pflanzenreste: 'ohne erkennbare Reste' },
		{ stufe: '10 (H10)', bezeichnung: 'völlig zersetzt', pflanzenstruktur: 'nicht erkennbar, völlig amorph', quetschen: 'gesamte Masse tritt durch', pflanzenreste: 'ohne erkennbare Reste' },
	];
}
